module.exports = __webpack_public_path__ + "img/Documentation.03e8e409.svg";